/*
 *
 * Home
 *
 */

import "../styles.scss";
import "moment/locale/pt";

import { API, Endpoints } from "utils/api";
import { Col, ConfigProvider, DatePicker, Drawer, Input, Modal, Row, Select, notification } from "antd";
import EventBanner from "./EventBanner";
import { Icons, SimpleAppointmentCard } from "components";
import Strings, { renderString } from "utils/strings";
import {
	setBreadcrumb,
	setBusiness,
	setLoader,
	setRoom,
	setUnreadChatMessages,
	setUser,
	setVideoSettings
} from "store/actions";

import { Footer } from "screens";
import { Helmet } from "react-helmet";
import React from "react";
import { connect } from "react-redux";
import en from "antd/es/locale/en_GB";
import finantialIcon from "assets/images/icon-financeiro.svg";
import healthInsuranceIcon from "assets/images/icon-segurosaude.svg";
import legalIcon from "assets/images/icon-juridico.svg";
import moment from "moment";
import nutritionalIcon from "assets/images/icon-nutricional.svg";
import pt from "antd/es/locale/pt_PT";
import { push } from "connected-react-router";
import { sanitizeHtml } from "utils/sanitizeHtml";
import socialIcon from "assets/images/icon-social.svg";
import taxIcon from "assets/images/icon-fiscal.svg";

const DEFAULT_QUESTIONS = [
	{
		question: Strings.home.question1,
		rating: null,
		type: "general",
		id: 1
	},
	{
		question: Strings.home.question2,
		rating: null,
		type: "psychologist",
		id: 2
	},
	{
		question: Strings.home.question3,
		rating: null,
		type: "pontuality",
		id: 3
	},
	{
		question: Strings.home.question4,
		rating: null,
		type: "feelingBetter",
		id: 4
	},
	{
		question: Strings.home.question5,
		rating: null,
		type: "consultationNumbers",
		id: 5
	},
	{
		question: Strings.home.question6,
		rating: null,
		type: "willBack",
		id: 6
	},
	{
		question: Strings.home.question7,
		rating: null,
		type: "recomendation",
		id: 7
	},
	{
		question: Strings.home.question8,
		rating: null,
		type: "motivation",
		id: 8
	},
	{
		question: Strings.home.question9,
		rating: null,
		type: "keepService",
		id: 10
	},
	{
		question: Strings.home.notes,
		notes: "",
		type: "notes",
		id: 11
	}
];

export class Home extends React.Component<any, any> {
	unmounted = false;

	constructor(props: any) {
		super(props);

		if (this.props.language === "pt") {
			moment.updateLocale("pt", {
				week: {
					dow: 1 /// Date offset
				}
			});
		} else {
			moment.updateLocale("en", {
				week: {
					dow: 1 /// Date offset
				}
			});
		}

		this.state = {
			appointments: [],
			events: [],
			serverNow: null,
			monthList: [
				moment.utc().format("MM YYYY"),
				moment.utc().add(1, "month").format("MM YYYY"),
				moment.utc().add(2, "month").format("MM YYYY"),
				moment.utc().add(3, "month").format("MM YYYY"),
				moment.utc().add(4, "month").format("MM YYYY"),
				moment.utc().add(5, "month").format("MM YYYY"),
				moment.utc().add(6, "month").format("MM YYYY")
			],
			selectedMonth: moment.utc().format("MM YYYY"),
			showDrawer: false,
			eap: null,
			nif: null,
			eapSupportText: "",
			selection: [],
			slots: [],
			finalSlots: [],
			reviewQuestions: JSON.parse(JSON.stringify(DEFAULT_QUESTIONS)),
			reviewPage: 1,
			starsHovered: {
				value: 0,
				id: null
			}
		};
	}

	componentDidMount() {
		const { dispatch } = this.props;
		dispatch(setBreadcrumb(null));

		this.getHome();
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	hasEAP() {
		const { business } = this.props;

		return (
			business?.serviceFinantial ||
			business?.serviceLegal ||
			business?.serviceTax ||
			business?.serviceNutritional ||
			business?.serviceSocial
		);
	}

	async getHome() {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.get({
				url: Endpoints.uriHome()
			});

			if (response.ok) {
				const {
					nextConsultation: appointments,
					business,
					user,
					reviewTreatment,
					events = [],
					serverNow = null
				} = response.data.results;
				dispatch(setUnreadChatMessages(user?.unreadChats || false));
				dispatch(setUser(user));

				if (business) dispatch(setBusiness(business));

				let showReviewModal = false;
				if (reviewTreatment?._id) {
					showReviewModal = true;
				}

				this.setState({ appointments, reviewTreatment, showReviewModal, events, serverNow });
			} else {
				notification.error({
					message: Strings.sidebar.home,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.home,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	// Event banner: cheap refresh of `events`/`serverNow` (GET /events/active) when a session starts or ends or the
	// tab comes back. Silent on purpose: no loader, no notification, the banner keeps what it has on failure.
	refreshEvents = async () => {
		try {
			const response: any = await API.get({
				url: Endpoints.uriEventsActive()
			});

			if (response.ok && !this.unmounted) {
				const { events = [], serverNow = null } = response.data.results || {};
				this.setState({ events, serverNow });
			}
		} catch (err) {
			// keep the current banner
		}
	};

	async getSlots(loader: boolean = false) {
		const { selectedMonth } = this.state;
		const { dispatch } = this.props;

		const body: any = {
			endDate: moment.utc(selectedMonth, "MM YYYY").endOf("month").format("YYYY-MM-DD")
		};

		if (moment.utc().month() === moment.utc(selectedMonth, "MM YYYY").month()) {
			body.startDate = moment.utc().format("YYYY-MM-DD");
		} else {
			body.startDate = moment.utc(selectedMonth, "MM YYYY").startOf("month").format("YYYY-MM-DD");
		}

		if (loader) {
			dispatch(setLoader(true));
		}

		let response: any;
		try {
			response = await API.post({
				url: Endpoints.uriSlots(),
				data: body
			});

			if (response.ok) {
				const { slots = [] } = response.data.results;

				const selection: Array<any> = [
					{
						month: moment.utc(selectedMonth, "MM YYYY").month(),
						year: moment.utc(selectedMonth, "MM YYYY").year(),
						days: []
					}
				];

				for (const slot of slots) {
					const newSelection = selection[0].days;
					const day = moment.utc(slot.date).date();
					if (!newSelection.includes(day)) {
						newSelection.push(day);
					}
				}

				let selectedDate: any;
				let finalSlots: Array<any> = [];
				if (slots.length) {
					selectedDate = moment.utc(slots[0].date);
					finalSlots = slots[0].slots || [];
				}

				this.setState({ selection, slots, selectedDate, finalSlots });
			} else {
				notification.error({
					message: Strings.appointments.header,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.appointments.header,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		if (loader) {
			dispatch(setLoader(false));
		}
	}

	async submitAppointment() {
		const { selectedDate, selectedSlot } = this.state;
		const { dispatch, user } = this.props;

		if (!selectedDate || !selectedSlot) return;

		dispatch(setLoader(true));

		let response: any;
		try {
			const body = {
				date: moment.utc(selectedDate).format("YYYY-MM-DD"),
				time: selectedSlot,
				user: user._id
			};

			response = await API.post({
				url: Endpoints.uriAppointments(),
				data: body
			});

			if (response.ok) {
				this.setState({ showDrawer: false });

				await this.getHome();

				notification.success({
					message: Strings.appointments.header,
					description: Strings.appointments.created,
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.appointments.header,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.appointments.header,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async submitReview(skip: boolean = false) {
		const { reviewQuestions, reviewTreatment } = this.state;
		const { dispatch } = this.props;

		if (!skip) {
			if (reviewQuestions.some((question: any) => question.type !== "notes" && !question.rating)) {
				return notification.warn({
					message: Strings.home.treatmentRating,
					description: Strings.home.questionsNotAnswered,
					placement: "bottomRight",
					duration: 5
				});
			}
		}

		dispatch(setLoader(true));

		let response: any;
		try {
			const body = {} as any;
			if (!skip) {
				reviewQuestions.forEach((question: any) => {
					if (question.type !== "notes") {
						body[question.type] = question.rating;
					} else {
						body[question.type] = question.notes || "";
					}
				});
			} else {
				body.skip = true;
			}

			response = await API.patch({
				url: Endpoints.uriReviews(reviewTreatment?._id),
				data: body
			});

			if (response.ok) {
				this.setState({
					reviewQuestions: JSON.parse(JSON.stringify(DEFAULT_QUESTIONS)),
					reviewTreatment: null,
					showReviewModal: false
				});

				notification.success({
					message: Strings.home.treatmentRating,
					description: Strings.home.reviewSent,
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.home.treatmentRating,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.home.treatmentRating,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	disabledDate = (current: any) => {
		const { selection } = this.state;
		const available = selection.some(
			(entry: any) =>
				current.year() === entry.year && current.month() === entry.month && entry.days.includes(current.date())
		);

		return !available;
	};

	startVideoCall = async (id: any, user?: any) => {
		const { dispatch, room, audioRoom } = this.props;

		if (room || audioRoom) {
			return notification.warn({
				message: Strings.home.pendingCalls,
				description: Strings.home.cantAcceptCall,
				placement: "bottomRight",
				duration: 5
			});
		}

		const response = await API.get({
			url: Endpoints.uriVideoCalls(`consultation/${id}`)
		});

		if (response.ok) {
			const { twilioRoom, userToken } = response.data.results;

			this.setState(
				{
					activeRoom: twilioRoom.roomSid,
					roomName: twilioRoom.uniqueName,
					room: twilioRoom,
					roomState: "disconnected",
					roomNameErr: false,
					previewTracks: null,
					token: userToken,
					localMediaAvailable: true,
					hasJoinedRoom: true,
					openVideoCallModal: true
				},
				() => {
					const room = { ...twilioRoom, user };
					dispatch(setRoom(room));
					dispatch(setVideoSettings({ token: userToken, activeVideo: true, room, appointmentId: id }));
				}
			);
		} else {
			this.setState({ roomNameErr: true });

			return notification.error({
				message: Strings.serverErrors.title,
				description: Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
	};

	getClassification(value: number) {
		switch (value) {
			case 1:
				return Strings.home.notReally;
			case 2:
				return Strings.home.little;
			case 3:
				return Strings.home.few;
			case 4:
				return Strings.home.many;
			case 5:
				return Strings.home.alot;
			default:
				return "";
		}
	}

	renderDrawerContent() {
		const { monthList, slots, selectedSlot, selectedDate, selectedMonth, selection, finalSlots } = this.state;
		const { language } = this.props;

		return (
			<div className="AppointmentsDrawer">
				<Row gutter={[10, 30]}>
					<Col xs={12}>
						<label htmlFor="drawer_month" className="InputLabel --label-required">
							{Strings.appointments.selectMonth}
						</label>
						<Select
							id="drawer_month"
							className="AppointmentsDrawerFullWidth"
							placeholder={Strings.appointments.selectMonth}
							showSearch
							allowClear={false}
							filterOption={(input: any, option: any) =>
								option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
							value={selectedMonth || null}
							onChange={(selectedMonth: any) =>
								this.setState({ selectedMonth }, () => this.getSlots(true))
							}
						>
							{monthList.map((month: string) => {
								let finalMonth = moment.utc(month, "MM YYYY").format("MMMM YYYY");

								return (
									<Select.Option key={`month_${month}`} value={month}>
										{`${finalMonth.substring(0, 1).toUpperCase()}${finalMonth.substring(1)}`}
									</Select.Option>
								);
							})}
						</Select>
					</Col>
					<Col xs={12}>
						<label htmlFor="drawer_day" className="InputLabel --label-required">
							{Strings.appointments.selectDate}
						</label>
						<ConfigProvider locale={language === "pt" ? pt : en}>
							<DatePicker
								id="drawer_day"
								dropdownClassName="AppointmentsDatePicker"
								className="AppointmentsDrawerFullWidth"
								disabledDate={this.disabledDate}
								disabled={!selection.length}
								suffixIcon={<Icons.Calendar date color="blue" />}
								allowClear={false}
								value={selectedDate || null}
								onChange={(value: any) => {
									const slot = slots.find(
										(tmpSlot: any) => moment.utc(tmpSlot.date).date() === value.date()
									);
									this.setState({ selectedDate: value, finalSlots: slot.slots });
								}}
							/>
						</ConfigProvider>
					</Col>
					<Col xs={24}>
						<label htmlFor="drawer_slots" className="InputLabel --label-required">
							{Strings.appointments.availableSlots}
						</label>
						<div className="DrawerSlots">
							{finalSlots.map((slot: number, index: number) => {
								return (
									<button
										key={`slot_${slot}_${index}`}
										className={`DrawerSlot${selectedSlot === slot ? " --slot-selected" : ""}`}
										onClick={() =>
											this.setState({
												selectedSlot: slot
											})
										}
									>
										<p>{slot}</p>
									</button>
								);
							})}
							{finalSlots.length === 0 && <p>{Strings.appointments.noSlots}</p>}
						</div>
					</Col>
				</Row>
			</div>
		);
	}

	renderDrawer() {
		const { showDrawer } = this.state;
		const { mobile } = this.props;

		return (
			<Drawer
				title={<h2 className="DrawerTitle">{Strings.appointments.schedule}</h2>}
				footer={
					<div className="DrawerFooter">
						<button
							className="DrawerFooterButton"
							onClick={() =>
								this.setState({
									tempAppointment: null,
									submitType: null,
									showDrawer: false
								})
							}
						>
							{Strings.appointments.cancel}
						</button>
						<button className="DrawerFooterButton --btn-primary" onClick={() => this.submitAppointment()}>
							{Strings.appointments.confirm}
						</button>
					</div>
				}
				className="drawer"
				width={mobile ? "100%" : 400}
				placement="right"
				closable={true}
				visible={showDrawer}
				onClose={() => this.setState({ showDrawer: false })}
			>
				{this.renderDrawerContent()}
			</Drawer>
		);
	}

	async submitContact(title: any, nif: any) {
		const { eapSupportText, eap } = this.state;
		const { dispatch } = this.props;

		const rawTitleHtml = title?.props?.dangerouslySetInnerHTML?.__html || "";
		const tempElement = document.createElement("div");
		tempElement.innerHTML = sanitizeHtml(String(rawTitleHtml));
		const plainTextTitle = tempElement.textContent || tempElement.innerText || "";

		if (eap === "healthInsurance" && !nif) {
			notification.warn({
				message: plainTextTitle,
				description: Strings.errors.invalidFields,
				placement: "bottomRight",
				duration: 5
			});
			return;
		}

		if (!eapSupportText?.trim() || !plainTextTitle?.trim()) {
			return notification.warn({
				message: plainTextTitle,
				description: Strings.errors.invalidFields,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.post({
				url: Endpoints.uriSupport(),
				data: {
					subject: plainTextTitle,
					message: eapSupportText,
					eap: eap,
					nif: nif
				}
			});

			if (response.ok) {
				this.setState({
					eap: null,
					eapSupportText: "",
					nif: null
				});

				notification.success({
					message: plainTextTitle,
					description: Strings.profile.contactSent,
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: plainTextTitle,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: plainTextTitle,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	renderEAPDrawer() {
		const { eap, eapSupportText, nif } = this.state;
		const { mobile, business } = this.props;

		const getEAPText = (eap: String) => {
			switch (eap) {
				case "finantial":
					return renderString(Strings.eap.finantial);
				case "legal":
					return renderString(Strings.eap.legal);
				case "tax":
					return renderString(Strings.eap.tax);
				case "social":
					return renderString(Strings.eap.social);
				case "nutritional":
					return renderString(Strings.eap.nutritional);
				case "healthInsurance":
					return renderString(Strings.eap.healthInsurance);
				default:
					return null;
			}
		};

		const getEAPIcon = (eap: String) => {
			switch (eap) {
				case "finantial":
					return finantialIcon;
				case "legal":
					return legalIcon;
				case "tax":
					return taxIcon;
				case "social":
					return socialIcon;
				case "nutritional":
					return nutritionalIcon;
				case "healthInsurance":
					return healthInsuranceIcon;
				default:
					return "";
			}
		};

		return (
			<Drawer
				title={<h2 className="DrawerTitle">{renderString(Strings.home.eapSupportRequest)}</h2>}
				footer={
					<div className="DrawerFooter EAPDrawerFooter">
						{eap === "healthInsurance" && business?.serviceHealthInsuranceLink && (
							<button
								className="DrawerFooterButton EAPDrawerButton"
								onClick={() => {
									window.open(business?.serviceHealthInsuranceLink, "_blank");
								}}
							>
								{Strings.sidebar.conditions}
							</button>
						)}
						<button
							className="DrawerFooterButton --btn-primary EAPDrawerButton"
							onClick={() => {
								if (eap) this.submitContact(getEAPText(eap), nif);
							}}
						>
							{Strings.contactUs.send}
						</button>
					</div>
				}
				className="drawer"
				width={mobile ? "100%" : 400}
				placement="right"
				closable={true}
				visible={Boolean(eap)}
				onClose={() => this.setState({ eap: null, eapSupportText: "", nif: "" })}
			>
				<div className="EAPDrawerContent">
					<div>
						<img alt="Legal Icon" src={getEAPIcon(eap)} />
						<h3>{getEAPText(eap)}</h3>
						<div className="EAPSupportText">
							<p>{Strings.eap.text}</p>
						</div>
					</div>
					{eap === "healthInsurance" && (
						<Input
							id="form_nif"
							value={nif || ""}
							className="ProfileInput"
							placeholder={Strings.eap.nif}
							onChange={(e: any) => {
								this.setState({
									nif: e.target.value
								});
							}}
						/>
					)}
					<Input.TextArea
						id="form_subject"
						value={eapSupportText || ""}
						className="ProfileInput EAPDrawerInput"
						required
						rows={10}
						placeholder={Strings.placeholders.description}
						onChange={(e: any) => {
							this.setState({
								eapSupportText: e.target.value
							});
						}}
					/>
				</div>
			</Drawer>
		);
	}

	renderReviewModal() {
		const { showReviewModal } = this.state;
		const { mobile } = this.props;

		return (
			<Modal
				centered={true}
				closable={false}
				visible={showReviewModal}
				footer={null}
				width={mobile ? "100%" : 1000}
			>
				<div className="TreatmentReviewModal">
					<div className="TreatmentReviewHeader">
						<h2>{Strings.home.treatmentRating}</h2>
						<button onClick={() => this.submitReview(true)}>
							<p>{Strings.home.skip}</p>
						</button>
					</div>
					<p className="TreatmentReviewHelp">
						{Strings.formatString(
							Strings.home.reviewHelp as string,
							<span className="TreatmentReviewHighlight">1</span>,
							<span className="TreatmentReviewHighlight">5</span>,
							<span className="TreatmentReviewHighlight">1</span>,
							<span className="TreatmentReviewHighlight">{Strings.home.notReally}</span>,
							<span className="TreatmentReviewHighlight">5</span>,
							<span className="TreatmentReviewHighlight">{Strings.home.alot}</span>
						)}
					</p>
					<div className="TreatmentQuestions">{this.renderReviewQuestions()}</div>
					<div className="TreatmentReviewFooter">
						<button onClick={() => this.submitReview()} className="TreatmentReviewSubmit">
							{Strings.contactUs.send}
						</button>
					</div>
				</div>
			</Modal>
		);
	}

	renderReviewQuestions() {
		const { reviewQuestions, reviewPage, starsHovered } = this.state;

		return (
			<Row gutter={[100, 40]}>
				{reviewQuestions
					.slice(0 + (reviewPage - 1) * 10, reviewPage * 10)
					.map((question: any, index: number) => {
						const isStarQuestion = question.type !== "notes";

						return (
							<Col key={`question_${index}`} xs={24} md={12}>
								<div className="ReviewSingleQuestion">
									<p>{question.question}</p>
									{isStarQuestion ? (
										<div className="ReviewRating">
											{Array(5)
												.fill("")
												.map((star: string, idx: number) => {
													let className = "";

													if (
														idx <= starsHovered?.value &&
														starsHovered?.id === question.id
													) {
														className = "-btn--hovered";
													} else if (idx + 1 <= (question.rating || 0)) {
														className = "-btn--selected";
													}

													return (
														<button
															key={`star_${idx}`}
															className={className}
															onMouseEnter={() =>
																this.setState({
																	starsHovered: { value: idx, id: question.id }
																})
															}
															onMouseLeave={() =>
																this.setState({ starsHovered: { value: 0, id: null } })
															}
															onClick={() => {
																question.rating = idx + 1;
																this.setState({ reviewQuestions });
															}}
														>
															<Icons.Star />
														</button>
													);
												})}
											{question.rating && <p>({this.getClassification(question.rating)})</p>}
										</div>
									) : (
										<Input.TextArea
											placeholder={Strings.home.typeNote}
											value={question?.value}
											onChange={(e: any) => {
												question.notes = e.target.value;
												this.setState({ reviewQuestions });
											}}
											rows={4}
										/>
									)}
								</div>
							</Col>
						);
					})}
			</Row>
		);
	}

	render() {
		const { business, dispatch, mobile, language } = this.props;
		const { appointments, events, serverNow } = this.state;

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.sidebar.home} | Team24</title>
					<meta name="description" content="Description of Home" />
				</Helmet>
				<div className="HomeContent">
					<div className="HomeMainWrapper">
						{events?.length > 0 && (
							<EventBanner
								events={events}
								serverNow={serverNow}
								language={language}
								onRefresh={this.refreshEvents}
							/>
						)}
						<h1>{renderString(Strings.home.psychologicalSupportRequest)}</h1>
						<div className="HomeCardsWrapper">
							<SimpleAppointmentCard
								homeUser
								empty={appointments.length === 0}
								appointment={appointments.length > 0 ? appointments[0] : null}
								onClick={async () => {
									if (appointments.length === 0) {
										await this.getSlots();
										this.setState({ showDrawer: true });
									} else {
										this.startVideoCall(appointments[0]?._id, appointments[0]?.psychologist);
									}
								}}
							/>
							{mobile && (
								<div className="HomeMobileNextAppointments">
									<h2>
										{appointments?.length > 0
											? Strings.home.scheduledAppointments
											: Strings.home.noAppointments}
									</h2>
									<div className="AppointmentsList">
										{appointments.map((appointment: any) => (
											<SimpleAppointmentCard
												key={`appointment_${appointment._id}`}
												simple
												appointment={appointment}
											/>
										))}
									</div>
								</div>
							)}
							<div className="ChatCardWrapper">
								<div className="ChatBackground" />
								<h2>{Strings.home.needChat}</h2>
								<button onClick={() => dispatch(push("/chat", { startChat: true }))}>
									{Strings.home.startChat}
								</button>
							</div>
						</div>
						{this.hasEAP() && <h2>{renderString(Strings.home.eapSupportRequest)}</h2>}
						<div className="HomeEapServiceCardWraper">
							{business?.serviceFinantial && (
								<div className="HomeEapServiceCard">
									<img alt="Financial Icon" src={finantialIcon} />
									<h3>{renderString(Strings.eap.finantial)}</h3>
									<button onClick={() => this.setState({ eap: "finantial" })}>
										{Strings.generic.request}
									</button>
								</div>
							)}
							{business?.serviceLegal && (
								<div className="HomeEapServiceCard">
									<img alt="Legal Icon" src={legalIcon} />
									<h3>{renderString(Strings.eap.legal)}</h3>
									<button onClick={() => this.setState({ eap: "legal" })}>
										{Strings.generic.request}
									</button>
								</div>
							)}
							{business?.serviceTax && (
								<div className="HomeEapServiceCard">
									<img alt="Tax Icon" src={taxIcon} />
									<h3>{renderString(Strings.eap.tax)}</h3>
									<button onClick={() => this.setState({ eap: "tax" })}>
										{Strings.generic.request}
									</button>
								</div>
							)}
							{business?.serviceSocial && (
								<div className="HomeEapServiceCard">
									<img alt="Social Icon" src={socialIcon} />
									<h3>{renderString(Strings.eap.social)}</h3>
									<button onClick={() => this.setState({ eap: "social" })}>
										{Strings.generic.request}
									</button>
								</div>
							)}
							{business?.serviceNutritional && (
								<div className="HomeEapServiceCard">
									<img alt="Nutritional Icon" src={nutritionalIcon} />
									<h3>{renderString(Strings.eap.nutritional)}</h3>
									<button onClick={() => this.setState({ eap: "nutritional" })}>
										{Strings.generic.request}
									</button>
								</div>
							)}
							{business?.serviceHealthInsurance && (
								<div className="HomeEapServiceCard">
									<img alt="HealthInsurance Icon" src={healthInsuranceIcon} />
									<h3>{renderString(Strings.eap.healthInsurance)}</h3>
									<button onClick={() => this.setState({ eap: "healthInsurance" })}>
										{Strings.generic.request}
									</button>
								</div>
							)}
						</div>
					</div>
					<div className="FutureAppointmentsWrapper">
						<h2>
							<strong>
								{appointments?.length > 0
									? Strings.home.scheduledAppointments
									: Strings.home.noAppointments}
							</strong>
						</h2>
						<div className="AppointmentsList">
							{appointments.map((appointment: any) => (
								<SimpleAppointmentCard
									key={`appointment_${appointment._id}`}
									simple
									appointment={appointment}
									onCardClick={() => dispatch(push("/appointments"))}
								/>
							))}
						</div>
					</div>
				</div>
				{mobile && <Footer />}
				{this.renderDrawer()}
				{this.renderEAPDrawer()}
				{this.renderReviewModal()}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language,
	business: state.business,
	user: state.user,
	mobile: state.mobile,
	room: state.room,
	audioRoom: state.audioRoom
});

export default connect(mapStateToProps)(Home);
